var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-header",attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"},on:{"select":_vm.handleSelect}},_vm._l((_vm.menuList),function(i){return _c('el-menu-item',{key:i.path,attrs:{"index":i.path}},[_vm._v(_vm._s(i.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }